// @comfy/shared — 尺寸规范化纯逻辑
// 设计依据 design.md「Data Models」/「Correctness Properties」Property 3。
// Validates: Requirements 7.3, 7.4
// DEFAULT_DIMS 已在 types.ts 定义（合法默认尺寸，宽高均为 16 倍数）。
// 此处 re-export，便于尺寸相关逻辑从单一模块引用。
export { DEFAULT_DIMS } from "./types.js";
/**
 * 将任意正整数规范化为最接近的 16 的倍数，且结果恒 ≥16。
 *
 * 规则（对应 Property 3）：
 * - 输出恒为 16 的倍数；
 * - 输出恒 ≥16；
 * - 与（钳制后）输入之差 <16。
 *
 * 非整数输入会先四舍五入；小于 16 的输入被钳制到 16。
 *
 * @param n 任意数值（期望为正整数；非整数将被四舍五入）
 * @returns 最接近的、≥16 的 16 倍数
 */
export function normalizeTo16(n) {
    const clamped = Math.max(16, Math.round(n));
    return Math.max(16, Math.round(clamped / 16) * 16);
}
//# sourceMappingURL=dims.js.map